export const TESTIMONIALS = [
    {
        "testimonialImg": "/testimonials/1.jpg",
        "testimonialText": "Toshkent davlat texnika universiteti talabalari tomonidan Abdulla Qodiriy tavallud ayyomi munosabati bilan uning Adiblar xiyobonidagi monumentiga ehtirom ko'rsatildi.",
        "testimonialAuthor": "https://tdtu.uz/"
    },
    {
        "testimonialImg": "./testimonials/2.jpg",
        "testimonialText": "Toshkent davlat yuridik universiteti talabalari tomonidan G‘afur G‘ulom tavallud ayyomi munosabati bilan uning Adiblar xiyobonidagi monumentiga ehtirom ko'rsatildi.",
        "testimonialAuthor": "https://www.tsul.uz/uz"
    },
    {
        "testimonialImg": "./testimonials/3.jpg",
        "testimonialText": "O‘zbekiston davlat konservatoriyasi talabalari tomonidan Hamid Olimjon tavallud ayyomi munosabati bilan uning Adiblar xiyobonidagi monumentiga ehtirom ko'rsatildi.",
        "testimonialAuthor": "https://konservatoriya.uz/?lang=uz"
    },
    {
        "testimonialImg": "./testimonials/4.jpg",
        "testimonialText": "Toshkent to‘qimachilik va yengil sanoat instituti talabalari tomonidan Oybek tavallud ayyomi munosabati bilan uning Adiblar xiyobonidagi monumentiga ehtirom ko'rsatildi.",
        "testimonialAuthor": "https://web.ttyesi.uz/"
    },
    {
        "testimonialImg": "./testimonials/5.jpg",
        "testimonialText": "Toshkent davlat transport universiteti talabalari tomonidan Maqsud Shayxzoda tavallud ayyomi munosabati bilan uning Adiblar xiyobonidagi monumentiga ehtirom ko'rsatildi.",
        "testimonialAuthor": "https://tstu.uz/"
    },
    {
        "testimonialImg": "./testimonials/6.jpg",
        "testimonialText": "Toshkent moliya instituti talabalari tomonidan Abdulla Qahhor tavallud ayyomi munosabati bilan uning Adiblar xiyobonidagi monumentiga ehtirom ko'rsatildi.",
        "testimonialAuthor": "https://tfi.uz/uz-Latn"
    },
    {
        "testimonialImg": "./testimonials/7.jpg",
        "testimonialText": "Alisher Navoiy nomidagi Toshkent davlat o‘zbek tili va adabiyoti universiteti talabalari tomonidan Alisher Navoiy tavallud ayyomi munosabati bilan uning Adiblar xiyobonidagi monumentiga  ehtirom ko'rsatildi.",
        "testimonialAuthor": "https://www.tsuull.uz/"
    },
    {
        "testimonialImg": "./testimonials/8.jpg",
        "testimonialText": "O‘zbekiston Respublikasi Jamoat xavfsizligi universiteti kursantlari tomonidan Zahiriddin Muhammad Bobur tavallud ayyomi munosabati bilan uning Adiblar xiyobonidagi monumentiga ehtirom ko'rsatildi.",
        "testimonialAuthor": "https://mgjxu.uz/"
    },
    {
        "testimonialImg": "./testimonials/9.jpg",
        "testimonialText": "Toshkent arxitektura-qurilish instituti talabalari tomonidan Zokirjon Furqat tavallud ayyomi munosabati bilan uning Adiblar xiyobonidagi monumentiga ehtirom ko'rsatildi.",
        "testimonialAuthor": "https://taqi.uz/"
    },
    {
        "testimonialImg": "./testimonials/10.jpg",
        "testimonialText": "Toshkent pediatriya tibbiyot instituti talabalari tomonidan Berdaq tavallud ayyomi munosabati bilan uning Adiblar xiyobonidagi monumentiga ehtirom ko'rsatildi.",
        "testimonialAuthor": "https://tashpmi.uz/uz/"
    },
    {
        "testimonialImg": "./testimonials/11.jpg",
        "testimonialText": "O‘zbekiston xalqaro islom akademiyasi talabalari tomonidan Mahmudxo‘ja Behbudiy tavallud ayyomi munosabati bilan uning Adiblar xiyobonidagi monumentiga ehtirom ko'rsatildi.",
        "testimonialAuthor": "https://iiau.uz/oz"
    },
    {
        "testimonialImg": "./testimonials/12.jpg",
        "testimonialText": "Toshkent davlat pedagogika universiteti talabalari tomonidan Abdulla Avloniy tavallud ayyomi munosabati bilan uning Adiblar xiyobonidagi monumentiga ehtirom ko'rsatildi.",
        "testimonialAuthor": "https://new.tdpu.uz/"
    },
    {
        "testimonialImg": "./testimonials/13.jpg",
        "testimonialText": "Ichki ishlar vazirligi Akademiyasi kursantlari tomonidan Abdulhamid Cho‘lpon tavallud ayyomi munosabati bilan uning Adiblar xiyobonidagi monumentiga ehtirom ko'rsatildi.",
        "testimonialAuthor": "https://akadmvd.uz/"
    }
]
